import { motion } from "framer-motion";

const STATS = [
  {
    value: "12+",
    label: "Years in business",
    context: "Since 2013",
    sparkline: [20, 28, 32, 40, 46, 55, 62, 68, 72, 80, 88, 100],
  },
  {
    value: "240+",
    label: "Global clients",
    context: "Across 18 countries",
    sparkline: [12, 20, 28, 38, 48, 55, 65, 72, 80, 86, 92, 100],
  },
  {
    value: "$25M+",
    label: "Value managed",
    context: "In active engagements",
    sparkline: [15, 22, 30, 36, 46, 54, 60, 68, 75, 84, 92, 100],
  },
  {
    value: "4.9★",
    label: "Average rating",
    context: "Across 120+ projects",
    sparkline: [70, 78, 82, 85, 88, 90, 92, 93, 94, 95, 96, 98],
  },
];

function Sparkline({ data }) {
  const max = Math.max(...data);
  const pts = data.map((v, i) => `${(i / (data.length - 1)) * 100},${100 - (v / max) * 90}`).join(" ");
  return (
    <svg className="w-full h-10 mt-4" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
      <defs>
        <linearGradient id={`sg-${pts.substring(0, 8)}`} x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor="#5FD9C4" stopOpacity="0.35" />
          <stop offset="100%" stopColor="#5FD9C4" stopOpacity="0" />
        </linearGradient>
      </defs>
      <motion.polyline
        points={pts}
        fill="none"
        stroke="#5FD9C4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        initial={{ pathLength: 0 }}
        whileInView={{ pathLength: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      />
      <motion.polygon
        points={`0,100 ${pts} 100,100`}
        fill={`url(#sg-${pts.substring(0, 8)})`}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 1 }}
      />
    </svg>
  );
}

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="relative py-20 lg:py-24 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-10 max-w-xl">
          <h2 className="font-display text-3xl sm:text-4xl text-white tracking-tighter leading-[1.05] mb-3">
            <span className="eyebrow block font-mono-accent text-[11px] uppercase tracking-[0.25em] font-normal mb-4">
              / By the numbers
            </span>
            By the numbers
          </h2>
          <p className="text-brand-slate text-base lg:text-lg">
            A decade of delivery — backed by measurable outcomes, repeat clients, and a team that sticks around.
          </p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="bento-card rounded-2xl border border-white/8 bg-brand-navy/40 p-6 lg:p-7"
              data-testid={`stat-${i}`}
            >
              <div className="font-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tighter leading-none">
                {s.value}
              </div>
              <div className="mt-4 font-display text-base text-white/90 leading-tight">{s.label}</div>
              <div className="mt-1 font-mono-accent text-[10px] uppercase tracking-[0.22em] text-brand-mint">
                {s.context}
              </div>
              <Sparkline data={s.sparkline} />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
